import { AxiosResponse, AxiosError, AxiosResponseHeaders } from "axios"
import axios  from "./index"
import { AuthHeaders, QuestionnaireCount } from "../stores/store_types"

const callCountAnytimeConsultationQuestionnairesAPI = (headers: AuthHeaders, parameter: { corporationId: number, targetMonth: Date }, successCallback: (headers: AxiosResponseHeaders, questionnaireCount: QuestionnaireCount) => void, failureCallback: () => void) => {
  axios.get(
    "/api/v1/count_questionnaire/anytime_consultations",
    {
      headers: headers,
      params: {
        corporation_id: parameter.corporationId,
        target_month: parameter.targetMonth.toString()
      }
    }
  ).then((response: AxiosResponse) => {
    successCallback(response.headers, response.data["countQuestionnaire"])
  }).catch((error: AxiosError) => {
    console.error(error)
    failureCallback()
  })
}

const callCountNightConsultationQuestionnairesAPI = (headers: AuthHeaders, parameter: { corporationId: number, targetMonth: Date }, successCallback: (headers: AxiosResponseHeaders, questionnaireCount: QuestionnaireCount) => void, failureCallback: () => void) => {
  axios.get(
    "/api/v1/count_questionnaire/night_consultations",
    {
      headers: headers,
      params: {
        corporation_id: parameter.corporationId,
        target_month: parameter.targetMonth.toString()
      }
    }
  ).then((response: AxiosResponse) => {
    successCallback(response.headers, response.data["countQuestionnaire"])
  }).catch((error: AxiosError) => {
    console.error(error)
    failureCallback()
  })
}

const callCountDaytimeAdviceQuestionnairesAPI = (headers: AuthHeaders, parameter: { corporationId: number, targetMonth: Date }, successCallback: (headers: AxiosResponseHeaders, questionnaireCount: QuestionnaireCount) => void, failureCallback: () => void) => {
  axios.get(
    "/api/v1/count_questionnaire/daytime_advices",
    {
      headers: headers,
      params: {
        corporation_id: parameter.corporationId,
        target_month: parameter.targetMonth.toString()
      }
    }
  ).then((response: AxiosResponse) => {
    successCallback(response.headers, response.data["countQuestionnaire"])
  }).catch((error: AxiosError) => {
    console.error(error)
    failureCallback()
  })
}

export { callCountAnytimeConsultationQuestionnairesAPI, callCountNightConsultationQuestionnairesAPI, callCountDaytimeAdviceQuestionnairesAPI }
